import React from 'react';
import { Box, Paper, Table, TableHead, TableRow, TableCell, TableBody, Typography } from '@mui/material';

function normalizeColumns(columns) {
  const cols = Array.isArray(columns) ? columns : [];
  return cols.map((c) => {
    const key = c?.key ?? c?.field;
    const label = c?.label ?? c?.headerName ?? c?.title ?? '';
    return { ...c, key, label };
  });
}

export default function DataTable({ columns, rows, getKey, getRowId, loading, onRowClick }) {
  const cols = normalizeColumns(columns);
  const data = Array.isArray(rows) ? rows : [];
  const colCount = Math.max(cols.length, 1);

  const rowKey = (row) => {
    if (getKey) return getKey(row);
    if (getRowId) return getRowId(row);
    if (row && (row.id !== undefined && row.id !== null)) return String(row.id);
    return JSON.stringify(row);
  };

  const cellValue = (col, row) => {
    if (typeof col?.render === 'function') return col.render(row?.[col.key], row);
    if (typeof col?.renderCell === 'function') return col.renderCell({ row, value: row?.[col.key] });
    if (typeof col?.valueGetter === 'function') return col.valueGetter({ row, value: row?.[col.key] });
    return row?.[col.key];
  };

  return (
    <Paper sx={{ p: 0 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            {cols.map((col, idx) => (
              <TableCell key={String(col.key ?? idx)} align={col.align || 'left'}>
                {col.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {loading && data.length === 0 ? (
            <TableRow>
              <TableCell colSpan={colCount}>
                <Box p={2}>
                  <Typography variant="body2">Carregando…</Typography>
                </Box>
              </TableCell>
            </TableRow>
          ) : null}

          {!loading && data.length === 0 ? (
            <TableRow>
              <TableCell colSpan={colCount}>
                <Box p={2}>
                  <Typography variant="body2">Nenhum registro</Typography>
                </Box>
              </TableCell>
            </TableRow>
          ) : null}

          {data.map((row) => (
            <TableRow
              key={rowKey(row)}
              hover={Boolean(onRowClick)}
              onClick={onRowClick ? () => onRowClick(row) : undefined}
              sx={onRowClick ? { cursor: 'pointer' } : undefined}
            >
              {cols.map((col, idx) => (
                <TableCell key={String(col.key ?? idx)} align={col.align || 'left'}>
                  {cellValue(col, row)}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}
